import React from 'react';
import { useTranslation } from 'react-i18next';

import { ManageContractsApp } from '../contractManagementContext';
import ManageContractsRadio from '../ManageContractsRadioCheckbox';
import ManageContractsAddressFields from '../ManageContractsAddressFields';

export const MultipleOwners: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = ManageContractsApp.useDispatch();

  const { multipleOwners, multipleOwnersNewAddress } = ManageContractsApp.useState();

  return (
    <section className="manage-contracts-step stepMultipleOwners">
      <h3>{t('manageContracts:manageContracts.MultipleOwnersTitle')}*</h3>

      <div className="form-items">
        <ManageContractsRadio
          radioID="manageContractsMultipleOwnersNo"
          radioName="manageContractsMultipleOwners"
          onChangeFunc={(): void => dispatch(['changeMultipleOwners', false])}
          checkedComparison={!multipleOwners}
          label={`${t('manageContracts:manageContracts.MultipleOwnersNo')}`}
        />
        <ManageContractsRadio
          radioID="manageContractsMultipleOwnersYes"
          radioName="manageContractsMultipleOwners"
          onChangeFunc={(): void => dispatch(['changeMultipleOwners', true])}
          checkedComparison={multipleOwners}
          label={`${t('manageContracts:manageContracts.MultipleOwnersYes')}`}
        />
      </div>

      {multipleOwners && (
        <div className="form-item-sub-content">
          <p>{t('manageContracts:manageContracts.MultipleOwnersYesBody')}</p>
          <ManageContractsAddressFields
            address={multipleOwnersNewAddress}
            action="multipleOwnersNewAddress"
            showNameFields={true}
            showSSN={true}
            showMobilePhoneNumber={true}
          />
        </div>
      )}
    </section>
  );
};

export default MultipleOwners;
